import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AlmacenService } from 'src/app/services/api/almacen.service';
import Swal from 'sweetalert2';
import { DialogInventarioAventuraComponent } from '../inventario/dialog-inventario-aventura/dialog-inventario-aventura.component';
import * as moment from 'moment';
import { AventuraService } from 'src/app/services/api/aventura.service';

@Component({
  selector: 'app-reporte',
  templateUrl: './reporte.component.html',
  styleUrls: ['./reporte.component.css']
})
export class ReporteComponent implements OnInit {

  articulos: any = [];
  equipo: any

  displayedColumns: string[] = [
    'nombre',
    'marca',
    'modelo',
    'categoria',
    'fileNumber',
    'dateRange',

  ];

  dataSource: any;
  loading: boolean = true;

  selectMarca: string | null = null;
  selectModelo: string | null = null;
  selectTalla: string | null = null;
  selectCategoria: string | null = null;
  selectFile: string | null = null;

  arrayMarcas: any = [];
  arrayModelos: any = [];
  arrayTallas: any = [];
  arrayCategorias: any = [];
  arrayFiles: any = [];

  startDate: Date | any;
  endDate: Date | any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private cdr: ChangeDetectorRef, public dialog: MatDialog, private almacenService: AventuraService) {
  }

  ngOnInit() {
    this.getAllEquipos();
  }

  getAllEquipos() {
    this.almacenService.getAllEgresoEquipos().subscribe((response) => {

      console.log(response)
      this.articulos = response.getAllEgresoEquipos

      const marca = this.articulos.filter((item: any) => item.equipoInfo.marcaEquipo !== '' && item.equipoInfo.marcaEquipo !== null).map((item: any) => (item.equipoInfo.marcaEquipo))
      const modelo = this.articulos.filter((item: any) => item.equipoInfo.modeloEquipo !== '' && item.equipoInfo.modeloEquipo !== null).map((item: any) => (item.equipoInfo.modeloEquipo))
      const talla = this.articulos.filter((item: any) => item.equipoInfo.tallaEquipo !== '' && item.equipoInfo.tallaEquipo !== null).map((item: any) => (item.equipoInfo.tallaEquipo))
      const categoria = this.articulos.filter((item: any) => item.equipoInfo.categoria !== '' && item.equipoInfo.categoria !== null).map((item: any) => (item.equipoInfo.categoria))
      const file = this.articulos.filter((item: any) => item.fileNumber !== '' && item.fileNumber !== null).map((item: any) => (item.fileNumber))

      this.arrayMarcas = [...new Set(marca)]
      this.arrayModelos = [...new Set(modelo)]
      this.arrayTallas = [...new Set(talla)]
      this.arrayCategorias = [...new Set(categoria)]
      this.arrayFiles = [...new Set(file)]

      this.dataSource = new MatTableDataSource(this.articulos);

      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return data.fileNumber.toLowerCase().includes(filter) ||
        data.equipoInfo.nombreEquipo.toLowerCase().includes(filter) || 
        data.equipoInfo.marcaEquipo.toLowerCase().includes(filter) ||
        data.equipoInfo.categoria.toLowerCase().includes(filter) ||
        data.equipoInfo.modeloEquipo.toLowerCase().includes(filter);
      };

      this.dataSource.paginator = this.paginator
      this.loading = false
      return response;
    });

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterSelect() {

    let dataNew: any = this.articulos

    if (this.selectMarca) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo.marcaEquipo === this.selectMarca)

    } if (this.selectModelo) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo.modeloEquipo === this.selectModelo)

    } if (this.selectTalla) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo.tallaEquipo === this.selectTalla)

    } if (this.selectCategoria) {
      dataNew = dataNew?.filter((item: any) => item.equipoInfo.categoria === this.selectCategoria)

    } if (this.selectFile) {
      dataNew = dataNew?.filter((item: any) => item.fileNumber === this.selectFile)

    }
    if (this.startDate && this.endDate) {
      dataNew = dataNew?.filter((item: any) => {
        const fechas = item.fileDate.split(" - ");
        return new Date(this.startDate) <= moment(fechas[0].trim(), "DD.MM.YYYY").toDate() && moment(fechas[1].trim(), "DD.MM.YYYY").toDate() <= new Date(this.endDate)
      })
    }

    this.dataSource.data = dataNew

  }

  cleanDateSelected() {

    this.startDate = null
    this.endDate = null

    this.applyFilterSelect()

  }

}
